if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: '.foxkit-button'
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product__info .m-product-custom-field");
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product__info");
        this.mainAddToCart = this.mainProductForm.querySelector(this.selectors.addToCart);
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.mainProductFormHeight = this.mainProductForm.offsetHeight
        this.stickyHeaderHeight = document.querySelector('.m-header__top-wrapper').offsetHeight;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        this.init();
        this.setStickyAddToCartHeight();

        this.addEventListener( 'change', () => {
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find(variant => variant.id === Number(selectedVariantId));

          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
          }
        });

        document.addEventListener('matchMobile', () => {
          this.setStickyAddToCartHeight();
        });
        document.addEventListener('unmatchMobile', () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      getVariantWithInventoryData(variant) {
        if (!variant) return null;
        const hasInventoryFields =
          variant.inventory_management !== undefined &&
          variant.inventory_policy !== undefined &&
          variant.inventory_quantity !== undefined;
        if (hasInventoryFields) return variant;

        const themeProducts = window._themeProducts || {};
        const productData = themeProducts[this.productId];
        const inventoryVariant =
          productData && Array.isArray(productData.variants)
            ? productData.variants.find((item) => Number(item.id) === Number(variant.id))
            : null;

        if (!inventoryVariant) return variant;
        return {
          ...variant,
          inventory_management: variant.inventory_management ?? inventoryVariant.inventory_management,
          inventory_policy: variant.inventory_policy ?? inventoryVariant.inventory_policy,
          inventory_quantity: variant.inventory_quantity ?? inventoryVariant.inventory_quantity,
        };
      }

      isPreOrderVariant(variant) {
        const nextVariant = this.getVariantWithInventoryData(variant);
        if (!nextVariant) return false;
        const managedInventory = nextVariant.inventory_management !== null && nextVariant.inventory_management !== "";
        const continueSelling = nextVariant.inventory_policy === "continue";
        const inventoryQuantity = Number(nextVariant.inventory_quantity);
        return managedInventory && continueSelling && !Number.isNaN(inventoryQuantity) && inventoryQuantity <= 0;
      }

      init() {
        if (!this.mainAddToCart && !this.mainDynamicCheckout) {
          this.container.style.setProperty('--m-translate-y', 0);
          return;
        }
        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        if (buyNowBtn) this.enable_dynamic_checkout = true;
        let headerHeight = this.mainProductFormHeight - 40;
        if (document.querySelector('[data-sticky-type="always"]')) {
          headerHeight = this.mainProductFormHeight - this.stickyHeaderHeight - 40;
        }
        const rootMargin = `${headerHeight}px 0px 0px 0px`;
        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty('--m-translate-y', 0);
                } else {
                  this.container.style.setProperty('--m-translate-y', '100%');
                }
                document.documentElement.classList[entry.intersectionRatio != 1 ? "remove" : "add"]("stick-atc-show");
              });
            },
            { threshold: 1, rootMargin }
          );
        }
        
        prodTitle.addEventListener("click", () =>  __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
          });
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.sticky-atc-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > .m-add-to-cart--text');
  
        if (!addButton) return
  
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButton.classList.remove('disabled');
          const preorderText = window.MinimogStrings.preorder || "Pre-order";
          const defaultAtcText = window.MinimogStrings.addToCart || "Add to cart";
          const nextButtonText = this.isPreOrderVariant(this.currentVariant) ? preorderText : defaultAtcText;
          if (addButtonText) {
            addButtonText.textContent = nextButtonText;
          }
          addButton.setAttribute("data-atc-text", nextButtonText);
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, async (variant) => {
          variantInput.value = variant.id;
        });
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty('--f-sticky-atc-bar-height', this.offsetHeight + 'px');
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}
